/**
 * Lori Footer
 */

import React from 'react';
import { styled } from '@smooth-ui/core-sc';

const StyledLoriFooter = styled.div`
  background: linear-gradient(152deg, #d2232a 60%, #a5181c 100%);
  color: #fff;
  flex-shrink: 0;
  font-size: 14px;
  padding: 0.5em;
  text-align: center;
  width: 100%;

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const LoriFooter = () => (
  <StyledLoriFooter className="lori-footer" id="lori">
    Powered by LoRI from{' '}
    <a href="http://212f-labs.co.nz/" target="_blank" rel="noopener noreferrer">
      212f Labs
    </a>
  </StyledLoriFooter>
);

export default LoriFooter;
